import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, IconButton, TextField, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import io from 'socket.io-client';


// Transition component for the dialog
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CommentDialogBox = ({ open,setopen,selectedText ,setselectedText,role,agreementid,fetchcomment}) => {

  const [comment, setcomment] = useState('')

    function handleClose() {
        // setselectedText('')
        // selectedText=''
        // console.log('handleclose',selectedText);
        setopen(!open)
    }
  
    const handleSaveClick=()=> {
     
       const token = localStorage.getItem("token");
    
        axios
          .post(
            "http://localhost:8028/api/v1/actyv/savecomment",
            { documentId: agreementid,
              line:selectedText,
              role:role,
              comment:comment
             },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            console.log(response.data);
          });

          //fetch comments
          const socket = io('http://localhost:8028'); 

    socket.emit('new comment',1234,!fetchcomment)
          setcomment('')
          setopen(!open)
    }

    if (!open) return null;


  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        padding: 2,
        width: "400px",
        zIndex: 1000,
      }}
    >
        <Box><Typography>{`${selectedText.length>0?`"${selectedText.slice(0,60)}..."`:''}`}</Typography></Box>
      <Box display="flex" flexDirection="column">
        <TextField
          autoFocus
          margin="dense"
          label="Comment"
          type="text"
          fullWidth
          value={comment}
          onChange={(e)=>setcomment(e.target.value)}
        />
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSaveClick} color="primary">
            Save
          </Button>
        </Box>
      </Box>
    </Paper>
    // <Dialog open={open} onClose={handleClose}  sx={{
    //     '& .MuiDialog-container': {
    //       alignItems: 'flex-end',
    //       justifyContent: 'flex-end',
    //     },
    //     '& .MuiPaper-root': {
    //       margin: 2,
    //       maxWidth: '300px', // Adjust the width as needed
    //     },
    //   }}>
    //   <DialogTitle>{`"${selectedText.slice(0,50)}..."`}</DialogTitle>
    //   <DialogContent>
    //     <TextField
    //       autoFocus
    //       margin="dense"
    //       label="Comment"
    //       type="text"
    //       fullWidth
          
    //     //   onChange={handleChange}
    //     />
    //   </DialogContent>
    //   <DialogActions>
    //     <Button onClick={handleClose} color="primary">
    //       Cancel
    //     </Button>
    //     <Button onClick={handleSaveClick} color="primary">
    //       Save
    //     </Button>
    //   </DialogActions>
    // </Dialog>
  );
};

export default CommentDialogBox;